import { type FC, type PropsWithChildren } from 'react';

interface IProps extends PropsWithChildren {
  isOpen: boolean;
}

export const StickyBottomBar: FC<IProps> = ({ children, isOpen }) => (
  <div className="bcf" data-open={isOpen}>
    {children}
  </div>
);
